import { ApiError } from '@/lib/errors';

export const AC_MAPPING_ERROR_MESSAGES: Record<string, string> = {
  unknown_property: 'That Ahoy property no longer exists – pick another.',
  invalid_value: 'The value couldn’t be saved – check the field type matches.',
  unsupported_field_type: 'This field type isn’t supported for syncing.',
  mapping_not_found: 'This mapping no longer exists. Please refresh.',
  not_connected:
    'ActiveCampaign isn’t connected. Please reconnect and try again.',
  provisioning_failed: "We couldn't create the property. Try again.",
  invalid_request:
    'That value isn’t valid for this field – check it and try again.',
};

const DEFAULT_AC_MAPPING_ERROR_MESSAGE = 'Couldn’t save. Please try again.';

export function getAcMappingErrorMessage(error: unknown): string {
  const code =
    error instanceof ApiError
      ? (error.response as { error_code?: string } | undefined)?.error_code
      : undefined;
  return (
    (code && AC_MAPPING_ERROR_MESSAGES[code]) ||
    DEFAULT_AC_MAPPING_ERROR_MESSAGE
  );
}
